<template>
    <div class="form-group p-0-14"  style="border:1px solid #EAECEE; border-radius: 12px;"  :class="{'custom-field-ibox-content forms-ibox-padding white-bg': !isInquiry }" v-if="viewPage && !isInquiry">
        <div class="ibox rotate-div">
            <div :data-target="`#forms_checklists_toggle_${form.form_id}`"
                 @click="collapseAndExtendForm"
                 class="ibox-title"
                 style="border-top: 0px; border-radius: 12px !important; cursor: pointer;">
                <div class="col-xs-12 col-md-12 row" style="padding: 0px; margin: 0px;">
                    <div class="col-xs-10  col-md-6 p-0" style="padding: 0px; margin: 0px;">
                        <label  class="attribute-label  float-left"
                                role="button">
                            <label class="label-form new-design-heading-label">
                                {{ form.form_name }}
                            </label>
                        </label>
                    </div>

                    <div class="col-xs-2 col-md-6 p-0 inline float-right new-design-heading-label" style="padding: 0px">
                        <div class="inline arrow-container float-right" style="margin-left: 10px;">
                            <a class="" >
                                <i class="fa fa-chevron-down" style="color: #2E4051" ref="toggleIcon"></i>
                            </a>
                        </div>
                        <div  v-if="form.user_created_by" class="float-left mobile-hide">
                            <span style="font-size: 10px;" v-if="form.user_created_by.first_name && form.user_created_by.last_name">Updated  {{value.timedate}} by  {{form.user_created_by.first_name}} {{form.user_created_by.last_name}} ({{form.user_type}})</span>
                            <span style="font-size: 10px;" v-else>Updated  {{value.timedate}} by  {{form.user_created_by.email1}} ({{form.user_type}})</span>
                        </div>
                    </div>
                </div>
            </div>
            <div :id="`forms_checklists_toggle_${form.form_id}`" v-show="form.collapsed">
                <fieldset class="octopus-new-booking-fieldset col-md-12" style="padding: 0px 0px 0px 15px !important; margin: 0 !important; border: 0px solid #E0E2E5; list-style: none;">
                    <question v-for="(question, index) of form.questions"  :date-format="dateFormat" :time-format="timeFormat"
                              :key="index" v-model="value.questions[index]" :services="services" :s3-path="s3Path" :view-page="viewPage" :item-id="itemId" :form-id="form.form_id" ></question>
                    <div class="col-md-12 col-xs-12 "  style="padding: 0px; margin: 10px 0px 0px;" v-if="viewPage">
                        <div class="row"  style="padding: 0px; margin-bottom: 0px;">
                            <div class="col-md-12 col-xs-12 disktop-hide" v-if="! ( this.isInquiry ) ">
                                <li style="margin-bottom: 5px;"><span>Visible to: </span><span class="btn btn-primary btn-rounded blue-label-btn white-space-inherit ">{{form.visibility}}</span></li>
                                <li>
                                    <span> Display at:</span>
                                    <span  v-for="WhenToDisplay in form.WhenToDisplay" >
                                        <br  v-if="WhenToDisplay.display_option_id == 4"/>
                                        <span class="btn btn-primary btn-rounded blue-label-btn white-space-inherit" v-if="WhenToDisplay.display_option_id == 4">
                                            <span>{{ WhenToDisplay.display_option_name }} : </span>
                                            (
                                            <template v-for="(statusesName, index) in form.statusesName">
                                              {{ statusesName }}
                                              <span v-if="index !== form.statusesName.length - 1">, </span>
                                              <br v-if="(index + 1) % 3 === 0 && index !== form.statusesName.length - 1"/>
                                            </template>
                                            )
                                      </span>
                                       <span  class="btn btn-primary btn-rounded blue-label-btn white-space-inherit" v-else >{{WhenToDisplay.display_option_name}}</span>
                                      </span>
                                </li>
                            </div>
                            <div class="col-md-10 col-xs-6" v-if="! ( this.isInquiry ) ">
                                <div>
                                    <li style="margin:5px 4px; border:1px solid transparent; float: left;">
                                        <a :href="`/settings/forms/edit/${form.form_id}`" target="_blank" v-if="checkCredentialFormAndCheckList" title="Setting">
                                            <svg width="16" height="16" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                <path d="M0 14V16H6V14H0ZM0 2V4H10V2H0ZM10 18V16H18V14H10V12H8V18H10ZM4 6V8H0V10H4V12H6V6H4ZM18 10V8H8V10H18ZM12 6H14V4H18V2H14V0H12V6Z" fill="#2E4051"/>
                                            </svg>
                                        </a>
                                    </li>

                                    <li style="margin:5px 4px; border:1px solid transparent; float: left;" class="mobile-hide">
                                        Visible to:
                                    </li>
                                    <li class="btn btn-primary btn-rounded blue-label-btn white-space-inherit mobile-hide" style="margin:0px 4px; border:1px solid transparent; float: left;" >
                                       {{form.visibility}}
                                    </li>
                                    <li style="margin:5px 4px; border:1px solid transparent; float: left;" class="mobile-hide">
                                        Display at:
                                    </li>
                                    <li class="btn btn-primary btn-rounded blue-label-btn white-space-inherit mobile-hide" style="margin:0px 4px; border:1px solid transparent; float: left;">
                                       <span  v-for="(WhenToDisplay , indexDisplay) in form.WhenToDisplay" >
                                       <span v-if="WhenToDisplay.display_option_id == 4">
                                           <span> &nbsp;	 {{WhenToDisplay.display_option_name}}&nbsp;	  <span v-if="indexDisplay !== form.WhenToDisplay.length - 1">, </span> : </span>(
                                            <span v-for="(statusesName, index) in form.statusesName"> {{statusesName}}
                                                <span v-if="index !== form.statusesName.length - 1">, </span>
                                                <br v-if="index == 0 && (index + 1) % 1 === 0 && index !== form.statusesName.length - 1 &&  form.WhenToDisplay.length > 3"/>
                                                <br v-if="(index + 1) % 3 === 0 && index !== form.statusesName.length - 1 &&  form.WhenToDisplay.length < 3"/>
                                            </span>)
                                       </span>
                                       <span  v-else >&nbsp;	 {{WhenToDisplay.display_option_name}} &nbsp;	</span>
                                      </span>
                                    </li>
                                </div>
                            </div>
                            <div  :class="{ 'col-sm-12': isInquiry , 'col-md-2 col-xs-6 padding-edite-pin' : !isInquiry }">
                                <div class="float-right" data-toggle="modal"
                                     :data-target="`#edit_form_and_checklist_${form.form_id}_popup`" style="cursor: pointer; padding-top: 6px;" title="Edit">
                                    <svg data-v-42abf014="" width="20" height="20" viewBox="0 0 25 25" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path data-v-42abf014="" d="M11.06 6.02L11.98 6.94L2.92 16H2V15.08L11.06 6.02ZM14.66 0C14.41 0 14.15 0.1 13.96 0.29L12.13 2.12L15.88 5.87L17.71 4.04C18.1 3.65 18.1 3.02 17.71 2.63L15.37 0.29C15.17 0.09 14.92 0 14.66 0ZM11.06 3.19L0 14.25V18H3.75L14.81 6.94L11.06 3.19Z" fill="#2E4051"></path>
                                    </svg>
                                </div>
                            </div>

                        </div>
                    </div>
                </fieldset>

            </div>
        </div>
        <form-and-checklist-edit-popup
            :id="`edit_form_and_checklist_${form.form_id}_popup`"
            v-model="value"
            :s3-path="s3Path"
            :field-name="form.form_name"
            :date-format="dateFormat"
            :time-format="timeFormat"
            :item-id="itemId"
            :is-inquiry="isInquiry"
        ></form-and-checklist-edit-popup>
    </div>


    <div class="form-group p-0-14 "  :style=" `${custom_style_data}`" :class="{'custom-field-ibox-content add_border_to_div forms-ibox-padding white-bg additional-comments':true, 'custom-field-ibox-content-inquiry' : isInquiry}" v-else>
        <div class="ibox rotate-div">
            <div :data-target="`#forms_checklists_toggle_${form.form_id}`"
                 @click="collapseAndExtendForm"
                 class="ibox-title data_ibox_title_val "   >
                <div>
                    <label  class="attribute-label  float-left"
                            role="button">
                        <label class="label-form new-design-heading-label">
                            {{ form.form_name }}
                        </label>
                    </label>
                    <div class="inline float-right new-design-heading-label">
                        <div class="inline arrow-container float-right m-right-10 m-left-10 "  >
                            <a class="" role="button">
                                <i class="fa fa-chevron-down" style="color: #2E4051" ref="toggleIcon"></i>
                            </a>
                        </div>
                        <div  v-if="form.user_created_by" class="float-left">
                            <span style="font-size: 10px;" v-if="form.user_created_by.first_name && form.user_created_by.last_name">Updated  {{form.timedate}} by  {{form.user_created_by.first_name}} {{form.user_created_by.last_name}} ({{form.user_type}})</span>
                            <span style="font-size: 10px;" v-else>Updated  {{form.timedate}} by  {{form.user_created_by.email1}} ({{form.user_type}})</span>
                        </div>
                    </div>
                </div>
            </div>
            <div :id="`forms_checklists_toggle_${form.form_id}`" v-show="this.form.collapsed">
                <fieldset class="octopus-new-booking-fieldset col-md-12"    :style="`width: ${elementStyle}`">
                    <question v-for="(question, index) of form.questions" @questionMounted="onQuestionsMounted"  :date-format="dateFormat" :time-format="timeFormat"
                              :key="question.id" v-model="form.questions[index]" :services="services" :s3-path="s3Path" :view-page="viewPage" :is-inquiry="isInquiry"
                              :inquiry-id="inquiryId"
                    ></question>
                </fieldset>
            </div>
        </div>
    </div>
</template>

<script>

import {EventBus} from "../../../events/event-bus";

export default {
    name: "QForm",
    props: {
        value: {
            required: true,
            type: Object
        },
        viewPage:false,
        services: {
            type: Array,
            default() {
                return []
            }
        },
        isInquiry: {
            type: Number,
            default() {
                return 0
            }
        },
        dateFormat: {
            required: true,
            type: String
        },
        timeFormat: {
            required: true,
            type: String
        },
        formsLength: {
            required: false,
        },
        s3Path:{
            default() {
                return '';
            }
        },
        itemId:null,
        checkCredentialFormAndCheckList:false,
        inquiryId:0,

    },
    data() {
        return {
            form: this.value,
            questionsCountMounted:0,
            elementStyle: '100%',
            custom_style_data: ' ',
        }
    },
    methods: {

        getWidth() {
            let xWidth = null;
            if (window.screen != null)
                xWidth = window.screen.availWidth;

            if (window.innerWidth != null)
                xWidth = window.innerWidth;

            if (document.body != null)
                xWidth = document.body.clientWidth;

            return xWidth;
        },
        formInfoPopup() {
            window.popupi_alert(this.form.form_name, `info`);
        },
        collapseAndExtendForm() {
          if(this.form.collapsed){
                this.expandForm();

          } else{
              this.collapseForm();
          }
          this.$forceUpdate()
        },
        collapseForm() {
            this.form.collapsed = true;
            $(this.$refs.toggleIcon).toggleClass('rotate-180')

            EventBus.$emit('onChangeCheckListStatus',this.form.form_id , true);
        },
        expandForm() {
            this.form.collapsed = false;
            $(this.$refs.toggleIcon).toggleClass('rotate-180')

            EventBus.$emit('onChangeCheckListStatus',this.form.form_id , false);
        },
        onQuestionsMounted() {
            if (this.viewPage){
                this.questionsCountMounted++;
                if (this.questionsCountMounted===this.form.questions.length){
                    this.$emit('formsMounted');
                }
            }
        }
    },
    destroyed() {

    },
    mounted() {
        if (this.itemId){
            if(this.getWidth() <= 425) {
                this.elementStyle=" 100% !important ";
            }

            else if(this.getWidth() <= 725) {
                this.elementStyle=" 95% !important ";
            }
            else {
                this.elementStyle=" 98% !important ";
            }
        }else {
            if(this.getWidth() <= 425) {
                this.elementStyle="  100% !important ";
             this.custom_style_data ="  margin-bottom: 14px; ";
            }
            else if(this.getWidth() <= 725) {
                this.elementStyle=" 95% !important";
                this.custom_style_data ="    margin-bottom: 14px; ";

            }
            else {
                this.elementStyle=" 98% !important";
            }

        }
      EventBus.$on('onValidationError', value=>{
        if(this.form.form_id == value){
          this.collapseAndExtendForm();
          this.$forceUpdate();
        }
      });
    },
    watch: {
        form: {
            handler(form) {
                this.$emit('input', form);
            },
            deep: true,
            immediate: true
        },
    },

}
</script>
<style scoped>
.disktop-hide{
    display: none;
}
.add_border_to_div{
    border: 1px solid #EAECEE;
    border-radius: 12px;
}
.data_ibox_title_val
{
    border-top: 0px;padding: 14px 15px 15px;
    border-radius: 12px !important;
    cursor: pointer;
}
.custom-field-ibox-content {
    width: 100%;
}
.custom-field-ibox-content-inquiry {
    width: 46.5%;
}
@media (max-width: 767px) {
    .custom-field-ibox-content-inquiry {
        width: 100%;
    }
}

.border-none {
    border: none;
}

.p-left-unset {
    padding-left: unset;
}

.form-horizontal .form-group {
    margin-right: 0px;
    margin-left: 0px;
}
.new-design-heading-label {
    font-family: 'Roboto', serif;
    font-style: normal;
    font-weight: 600;
    font-size: 16px;
    line-height: 35px;
    color: #2E4051;
}

.additional-comments{
    padding-bottom: 10px !important;
}
.octopus-new-booking-fieldset{
    margin-top: 20px;
    margin-bottom: 0px;
    margin-left:10px !important;
    margin-right:10px !important;
    width: 98%;
}

@media (min-width: 768px) and (max-width: 1024px) {
    .octopus-new-booking-fieldset{
        width: 95% !important;
    }
    .disktop-hide{
        display: block;
    }
}

.custom-field{
    width: 100%;
}
.custom-field .new-inputs textarea {
    font: none !important;
}
.padding-edite-pin{
    padding: 0px 0.8%;
}
@media (max-width: 426px) {

    .octopus-new-booking-fieldset, fieldset{
        margin-left: 0px !important;
        margin-right: 0px !important;
    }
    .mobile-hide{
        display: none;
    }
  .octopus-new-booking-fieldset{
    width: 95% !important;
  }
  .padding-edite-pin{
      padding: 0px 3%;
  }
    .disktop-hide{
        display: block;
    }

}

.btn {
    padding: 4px 12px;
}


</style>